
{
  "familyId": "GET-BREUK-VEREENVOUDIG",
  "questions": [
    {
      "id": "GET-BREUK-VEREENVOUDIG-001",
      "familyId": "GET-BREUK-VEREENVOUDIG",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vereenvoudigen",
      "questionType": "multiple_choice",
      "question": "Vereenvoudig deze breuk: $\\frac{2}{4}$ =",
      "options": ["$\\frac{1}{2}$", "$\\frac{2}{4}$", "$\\frac{4}{8}$", "$\\frac{1}{4}$"],
      "correctAnswer": 0,
      "conceptId": "simplify_fraction_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 2,
            "denominator": 4,
            "label": "$\\frac{2}{4}$ — vereenvoudig dit",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 1,
            "denominator": 2,
            "label": "$\\frac{2}{4}$ = $\\frac{1}{2}$ (beide delen door 2)",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Vereenvoudigen: zoek het grootste getal waardoor je teller én noemer kunt delen. Bij $\\frac{2}{4}$: 2 ÷ 2 = 1 en 4 ÷ 2 = 2. Dus $\\frac{2}{4}$ = $\\frac{1}{2}$.",
        "solutionSteps": [
          "Zoek de GGD van 2 en 4: dat is 2",
          "Deel de teller: 2 ÷ 2 = 1",
          "Deel de noemer: 4 ÷ 2 = 2",
          "$\\frac{2}{4}$ = $\\frac{1}{2}$"
        ],
        "distractorExplanations": {
          "0": "Goed! 2 ÷ 2 = 1 en 4 ÷ 2 = 2, dus $\\frac{2}{4}$ = $\\frac{1}{2}$.",
          "1": "$\\frac{2}{4}$ is de oorspronkelijke breuk — die is nog niet vereenvoudigd. Deel teller én noemer door 2.",
          "2": "$\\frac{4}{8}$ is groter gemaakt (×2), niet vereenvoudigd. Je moet delen, niet vermenigvuldigen.",
          "3": "$\\frac{1}{4}$ klopt niet: je hebt alleen de teller door 2 gedeeld (2÷2=1), maar de noemer niet (4 blijft 4). Deel altijd beide door hetzelfde getal."
        }
      }
    },
    {
      "id": "GET-BREUK-VEREENVOUDIG-002",
      "familyId": "GET-BREUK-VEREENVOUDIG",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vereenvoudigen",
      "questionType": "multiple_choice",
      "question": "Vereenvoudig: $\\frac{6}{9}$ =",
      "options": ["$\\frac{2}{3}$", "$\\frac{3}{6}$", "$\\frac{6}{9}$", "$\\frac{1}{3}$"],
      "correctAnswer": 0,
      "conceptId": "simplify_fraction_thirds",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 6,
            "denominator": 9,
            "label": "$\\frac{6}{9}$ — vereenvoudig dit",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 2,
            "denominator": 3,
            "label": "$\\frac{6}{9}$ = $\\frac{2}{3}$ (beide delen door 3)",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij $\\frac{6}{9}$: de GGD van 6 en 9 is 3. Dus 6 ÷ 3 = 2 en 9 ÷ 3 = 3. Antwoord: $\\frac{2}{3}$.",
        "solutionSteps": [
          "Zoek de GGD van 6 en 9: dat is 3",
          "Deel de teller: 6 ÷ 3 = 2",
          "Deel de noemer: 9 ÷ 3 = 3",
          "$\\frac{6}{9}$ = $\\frac{2}{3}$"
        ],
        "distractorExplanations": {
          "0": "Goed! 6 ÷ 3 = 2 en 9 ÷ 3 = 3, dus $\\frac{6}{9}$ = $\\frac{2}{3}$.",
          "1": "$\\frac{3}{6}$ klopt niet: 6÷2=3 en 9÷2=4,5 — je kunt 9 niet door 2 delen. Zoek een getal dat in zowel 6 als 9 past: dat is 3.",
          "2": "$\\frac{6}{9}$ is de oorspronkelijke breuk — nog niet vereenvoudigd. Deel teller én noemer door 3.",
          "3": "$\\frac{1}{3}$ klopt niet: je hebt alleen de teller door 6 gedeeld (6÷6=1), maar de noemer niet correct (9÷6=1,5). Gebruik de GGD: 3."
        }
      }
    },
    {
      "id": "GET-BREUK-VEREENVOUDIG-003",
      "familyId": "GET-BREUK-VEREENVOUDIG",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vereenvoudigen",
      "questionType": "multiple_choice",
      "question": "Vereenvoudig: $\\frac{12}{16}$ =",
      "options": ["$\\frac{3}{4}$", "$\\frac{6}{8}$", "$\\frac{4}{5}$", "$\\frac{2}{3}$"],
      "correctAnswer": 0,
      "conceptId": "simplify_fraction_complex",
      "variantIndex": 3,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.75,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 12,
            "denominator": 16,
            "label": "$\\frac{12}{16}$ — vereenvoudig tot de eenvoudigste vorm",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "$\\frac{12}{16}$ = $\\frac{3}{4}$ (beide delen door 4)",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij $\\frac{12}{16}$: de GGD van 12 en 16 is 4. Dus 12 ÷ 4 = 3 en 16 ÷ 4 = 4. Antwoord: $\\frac{3}{4}$. Dit is de meest vereenvoudigde vorm.",
        "solutionSteps": [
          "Zoek de GGD van 12 en 16: dat is 4",
          "Deel de teller: 12 ÷ 4 = 3",
          "Deel de noemer: 16 ÷ 4 = 4",
          "$\\frac{12}{16}$ = $\\frac{3}{4}$ (eenvoudigste vorm)"
        ],
        "distractorExplanations": {
          "0": "Goed! 12 ÷ 4 = 3 en 16 ÷ 4 = 4, dus $\\frac{12}{16}$ = $\\frac{3}{4}$.",
          "1": "$\\frac{6}{8}$ is gedeeld door 2 (12÷2=6, 16÷2=8), maar dit is nog niet de eenvoudigste vorm. $\\frac{6}{8}$ kan nog verder: 6÷2=3 en 8÷2=4 = $\\frac{3}{4}$.",
          "2": "$\\frac{4}{5}$ klopt niet: 12÷4=3 (niet 4) en 16÷4=4 (niet 5). Controleer je deling.",
          "3": "$\\frac{2}{3}$ klopt niet: 12÷6=2 maar 16÷6=2,67 — 6 past niet in 16. Gebruik de GGD: 4."
        }
      }
    },
    {
      "id": "GET-BREUK-VEREENVOUDIG-004",
      "familyId": "GET-BREUK-VEREENVOUDIG",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vereenvoudigen",
      "questionType": "multiple_choice",
      "question": "Vereenvoudig: $\\frac{15}{20}$ =",
      "options": ["$\\frac{3}{4}$", "$\\frac{5}{10}$", "$\\frac{15}{20}$", "$\\frac{1}{2}$"],
      "correctAnswer": 0,
      "conceptId": "simplify_fraction_fifths",
      "variantIndex": 4,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.73,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 15,
            "denominator": 20,
            "label": "$\\frac{15}{20}$ — vereenvoudig tot de eenvoudigste vorm",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "$\\frac{15}{20}$ = $\\frac{3}{4}$ (beide delen door 5)",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij $\\frac{15}{20}$: de GGD van 15 en 20 is 5. Dus 15 ÷ 5 = 3 en 20 ÷ 5 = 4. Antwoord: $\\frac{3}{4}$.",
        "solutionSteps": [
          "Zoek de GGD van 15 en 20: dat is 5",
          "Deel de teller: 15 ÷ 5 = 3",
          "Deel de noemer: 20 ÷ 5 = 4",
          "$\\frac{15}{20}$ = $\\frac{3}{4}$"
        ],
        "distractorExplanations": {
          "0": "Goed! 15 ÷ 5 = 3 en 20 ÷ 5 = 4, dus $\\frac{15}{20}$ = $\\frac{3}{4}$.",
          "1": "$\\frac{5}{10}$ klopt niet: 15÷3=5 maar 20÷3=6,67 — 3 past niet in 20. Gebruik de GGD: 5.",
          "2": "$\\frac{15}{20}$ is de oorspronkelijke breuk — nog niet vereenvoudigd. Deel teller én noemer door 5.",
          "3": "$\\frac{1}{2}$ klopt niet: dat zou 15÷10=1,5 en 20÷10=2 zijn, maar 10 past niet in 15. De GGD is 5, niet 10."
        }
      }
    },
    {
      "id": "GET-BREUK-VEREENVOUDIG-005",
      "familyId": "GET-BREUK-VEREENVOUDIG",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vereenvoudigen",
      "questionType": "fill_in",
      "question": "Vereenvoudig $\\frac{4}{6}$. Typ je antwoord als breuk (bijv. 1/2).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["2/3", "²⁄₃"],
        "caseSensitive": false,
        "placeholder": "?/?"
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 4,
            "denominator": 6,
            "label": "$\\frac{4}{6}$ — vereenvoudig dit",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 2,
            "denominator": 3,
            "label": "$\\frac{4}{6}$ = $\\frac{2}{3}$ (beide delen door 2)",
            "visualType": "bar"
          }
        }
      ],
      "conceptId": "simplify_fraction_fill_basic",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Zoek de GGD van 4 en 6: dat is 2. Deel teller en noemer door 2: 4 ÷ 2 = 2 en 6 ÷ 2 = 3. Dus $\\frac{4}{6}$ = $\\frac{2}{3}$.",
        "solutionSteps": [
          "GGD van 4 en 6 = 2",
          "Teller: 4 ÷ 2 = 2",
          "Noemer: 6 ÷ 2 = 3",
          "$\\frac{4}{6}$ = $\\frac{2}{3}$"
        ]
      }
    },
    {
      "id": "GET-BREUK-VEREENVOUDIG-006",
      "familyId": "GET-BREUK-VEREENVOUDIG",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vereenvoudigen",
      "questionType": "fill_in",
      "question": "Vereenvoudig $\\frac{8}{12}$. Typ je antwoord als breuk (bijv. 1/2).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["2/3", "²⁄₃"],
        "caseSensitive": false,
        "placeholder": "?/?"
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 8,
            "denominator": 12,
            "label": "$\\frac{8}{12}$ — vereenvoudig tot de eenvoudigste vorm",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vereenvoudigen: zoek de GGD",
            "content": "De GGD van 8 en 12 is 4. Deel teller én noemer door 4: 8 ÷ 4 = 2 en 12 ÷ 4 = 3.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "simplify_fraction_fill_ggd",
      "variantIndex": 6,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De GGD van 8 en 12 is 4. Deel beide door 4: 8 ÷ 4 = 2 en 12 ÷ 4 = 3. Dus $\\frac{8}{12}$ = $\\frac{2}{3}$. Let op: als je door 2 deelt krijg je $\\frac{4}{6}$ — dat kan nog verder!",
        "solutionSteps": [
          "GGD van 8 en 12 = 4",
          "Teller: 8 ÷ 4 = 2",
          "Noemer: 12 ÷ 4 = 3",
          "$\\frac{8}{12}$ = $\\frac{2}{3}$"
        ]
      }
    },
    {
      "id": "GET-BREUK-VEREENVOUDIG-007",
      "familyId": "GET-BREUK-VEREENVOUDIG",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vereenvoudigen",
      "questionType": "fill_in",
      "question": "Vereenvoudig $\\frac{10}{15}$. Typ je antwoord als breuk (bijv. 1/2).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["2/3", "²⁄₃"],
        "caseSensitive": false,
        "placeholder": "?/?"
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 10,
            "denominator": 15,
            "label": "$\\frac{10}{15}$ — vereenvoudig dit",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vereenvoudigen met 5",
            "content": "Eindigen teller en noemer allebei op 0 of 5? Dan kun je door 5 delen. 10 ÷ 5 = 2 en 15 ÷ 5 = 3.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "simplify_fraction_fill_fives",
      "variantIndex": 7,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De GGD van 10 en 15 is 5. Deel beide door 5: 10 ÷ 5 = 2 en 15 ÷ 5 = 3. Dus $\\frac{10}{15}$ = $\\frac{2}{3}$.",
        "solutionSteps": [
          "GGD van 10 en 15 = 5",
          "Teller: 10 ÷ 5 = 2",
          "Noemer: 15 ÷ 5 = 3",
          "$\\frac{10}{15}$ = $\\frac{2}{3}$"
        ]
      }
    }
  ]
}
